import { EVENTS_SERVICE } from "@/services/events.service.js";

const state = {postEventOutput: false, getEventsOutput: {}, putEventOutput: false, deleteEventByIdOutput: false, getEventByIdOutput: {}, getEventBySlugOutput: {}};

const actions = {
    //Service to create events
    postEvent({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postEventRequest');

        EVENTS_SERVICE.postEvent(input)
            .then(
                output => {
                    commit('postEventSuccess', output);
                },
                error => {
                    commit('postEventFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated events
    getEvents({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getEventsRequest');

        EVENTS_SERVICE.getEvents(queryParams)
            .then(
                output => {
                    commit('getEventsSuccess', output);
                },
                error => {
                    commit('getEventsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update events
    putEvent({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putEventRequest');

        EVENTS_SERVICE.putEvent(input)
            .then(
                output => {
                    commit('putEventSuccess', output);
                },
                error => {
                    commit('putEventFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove events
    deleteEventById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteEventByIdRequest');

        EVENTS_SERVICE.deleteEventById(queryParams)
            .then(
                output => {
                    commit('deleteEventByIdSuccess', output);
                },
                error => {
                    commit('deleteEventByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get event details
    getEventById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getEventByIdRequest');

        EVENTS_SERVICE.getEventById(id)
            .then(
                output => {
                    commit('getEventByIdSuccess', output);
                },
                error => {
                    commit('getEventByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get event details
    getEventBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getEventBySlugRequest');

        EVENTS_SERVICE.getEventBySlug(queryParams)
            .then(
                output => {
                    commit('getEventBySlugSuccess', output);
                },
                error => {
                    commit('getEventBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postEvent
    postEventRequest(state) {
        state.postEventOutput = null;
    },
    postEventSuccess(state, output) {
        state.postEventOutput = true;
    },
    postEventFailure(state) {
        state.postEventOutput = false;
    },

    //getEvents
    getEventsRequest(state) {
    },
    getEventsSuccess(state, output) {
        state.getEventsOutput = output;
    },
    getEventsFailure(state) {
        state.getEventsOutput = false;
    },

    //putEvent
    putEventRequest(state) {
        state.putEventOutput = null;
    },
    putEventSuccess(state, output) {
        state.putEventOutput = true;
    },
    putEventFailure(state) {
        state.putEventOutput = false;
    },

    //deleteEventById
    deleteEventByIdRequest(state) {
        state.deleteEventByIdOutput = null;
    },
    deleteEventByIdSuccess(state, output) {
        state.deleteEventByIdOutput = true;
    },
    deleteEventByIdFailure(state) {
        state.deleteEventByIdOutput = false;
    },

    //getEventById
    getEventByIdRequest(state) {
    },
    getEventByIdSuccess(state, output) {
        state.getEventByIdOutput = output;
    },
    getEventByIdFailure(state) {
        state.getEventByIdOutput = false;
    },

    //getEventBySlug
    getEventBySlugRequest(state) {
    },
    getEventBySlugSuccess(state, output) {
        state.getEventBySlugOutput = output;
    },
    getEventBySlugFailure(state) {
        state.getEventBySlugOutput = false;
    },
};

export const events = {
    namespaced: true,
    state,
    actions,
    mutations
};